import React from 'react'

module.exports = {
    color_black: '曜石黑',
    color_orange: '愛馬仕橙',
    color_blue: '科技藍',
    pay_now: '立即支付',
    check_order: '檢視訂單',
    notifi_tryagain: '<i class="i-oc-queue"></i><h3>正在為閣下排隊中...</h3><p>目前搶購人數較多，正在努力為閣下載入，請稍後重試喔。</p>',
    notifi_yongdu: '<i class="i-oc-yongdu"></i><h3>抱歉，網路走丟了</h3><p>目前搶購人數較多，正在努力為閣下載入，請稍後重試喔。</p>',
    notifi_success: '<i class="i-oc-chenggong"></i><h3>恭喜，閣下已經成功搶到玩客雲1台</h3><p>支付有效期為45分鐘，請儘快完成支付，否則訂單將失效喔。</p>',
    notifi_chakan: '<i class="i-oc-chakan"></i><h3>每位玩客只能購買1台玩客雲</h3><p>閣下已經成功搶購，不要貪心哦。</p>',
    notifi_limit1: '<h3>請您先預約</h3><p>預約成功的用戶才能參與搶購玩客雲哦！</p>',

    login_remind: '為了方便購買，請提前登錄',
    login_now: '立即登錄',
    close: '關閉',
    ok: '確定',    
    pic_soldout: '已搶完',
    more: '已搶完',
    count_down1: '離搶購開始還有',
    count_down2: '正在搶購中...',
    buy_now: '立即購買',
    price_official: <span className="oc-buy-price-pay">官網購買：HK$720</span>,
    price_official_v2: <div className="np-buy-price">官網購買：<em><span>HK$720</span></em></div>,
    price_yuan: '元',
    price_total: <h3>合計：<strong>HK$720</strong></h3>,
    price_total_custom: props => <h3>合計：<strong>HK${props.price}</strong></h3>,
    price_presalle: <h3>預售價：<strong>HK$720</strong></ h3>,
    tips_deliver: '溫馨貼士：選擇送貨上門的用戶將於付款成功后7日內發貨，選擇自提取貨的用戶請在收到自提訊息后的7日內完成提貨。',
    goods_tip: <div className="np-buy-promise">
                    <i className="i-promise"></i>7天無理由退換貨&nbsp;&nbsp;&nbsp;&nbsp;
                    <i className="i-promise"></i>15天質量問題換貨&nbsp;&nbsp;&nbsp;&nbsp;
                    <i className="i-promise"></i>365天保修
                </div>,
    price_discount: props => <span className="oc-buy-price-pay">活動優惠價: HK${props.price} <s>HK$720</s></span>,
    tips_presell_deliver: '* 預售商品發貨時間將在閣下選定發貨時間內，按付款先後順序發出，網心保留提前發貨的權利。',
    submit_order: '提交訂單',

    banner_title: '玩客雲 自由暢快的個人雲盤',
    banner_subtitle:'2小時不限量火熱預定中',
    sub_title: <p>全新壹代共享智能硬件，用戶分享閑置的網絡帶寬、存儲空間以及計算資源</p>,
    presell_ing: '不限量預售开启中',
    deposit_number1: '已有',
    deposit_number2: '人預約',
    date_day: '天',
    date_hour: '時',
    date_minute: '分',
    date_second: '秒',

    colorcom_subtitle: '選擇顏色',
    colorcom_zero:'(售罄)', 
    delivercom_subtitle: '選擇發貨日期',

    imagecode_title: '驗證碼',
    imagecode_input: '請輸入圖形驗證碼',

    rtncode_30004: '目前時間不能搶購',
    rtncode_30006:  '狀態異常',
    rtncode_30007 : '已經搶購成功',
    rtncode_30008: '找不到訂單記錄',
    rtncode_30009: "沒有搶購到資格，無法支付",
    rtncode_30003: '已經預定過了',
    rtncode_40000: "非活動時間",
    rtncode_30106: '寶碼已經使用',
    rtncode__2: '系統繁忙，請稍後再試',
    rtncode__2004: '本期已經售罄',
    rtncode__2000: '搶購未開始',
    rtncode__1003: '寶碼已被使用',
    rtncode__5: '超過頻率限制，請稍後再試',
    rtncode_41006: '訂單已逾時，請規定時間內付款',
    rtncode_41007: '<h3>您的訂單提交失敗</h3><p>您在預售訂單生成後實際付款前有超過2次超時未支付訂單，已失去繼續參與本次預售活動的資格，感謝您的支持。</p>',
    rtncode_41007_2: '購買次數超過限制',
    rtncode_41009: '已支付',
    rtncode_41013: '沒有這個發貨日期了',
    rtncode_41014: '系統繁忙，請稍後再次重新整理',
    rtncode_41016: '訂單不存在',
    rtncode_41008: '<h3>每位用戶限購1台玩客雲</h3><p>爲充分保證廣大玩客的利益，已成功在官網購買過的用戶，將不再參與本次玩客雲預售，請您諒解。</p>',
    rtncode__301: '<h3>當前賬號異常</h3><p>系統檢測到您當前賬號存在異常行爲記錄，您將無法參與本次購買，請您諒解。</p>',
    rtncode_30032: '<h3>當前賬號異常</h3><p>系統檢測到您當前賬號存在異常行爲記錄，您將無法參與本次購買，請您諒解。</p>',
    rtncode_41011: '<h3>您的訂單提交失敗</h3><p>您在預售訂單生成後實際付款前有超過2次超時未支付訂單，已失去繼續參與本次預售活動的資格，感謝您的支持。</p>',
    rtncode__1: '參數不合法',
    rtncode_41010: '<h3>您有1筆未支付訂單</h3><p>檢測到您存在一筆未支付預售訂單，請您盡快完成付款。如果超時未支付，本次訂單將自動失效。</p>',
    rtncode_30005: '<i class="i-oc-sorry"></i><h3>抱歉，本輪玩客雲已售罄</h3><p>在您選購顔色時，我們的玩客雲已經售罄，請不要灰心，悄悄的告訴您，您可免預約直接參與下期搶購喔。</p>',
    rtncode_30016: '<i class="i-oc-sorry"></i><h3>抱歉，曜石黑已售罄</h3><p>都是我不好，人數太多，機器太少，曜石黑已售罄，建議您嘗試選擇其他顔色喔。</p>',
    rtncode_30025: '<i class="i-oc-sorry"></i><h3>抱歉，愛馬仕橙已售罄</h3><p>都是我不好，人數太多，機器太少，愛馬仕橙已售罄，建議您嘗試選擇其他顔色喔。</p>',
    rtncode_30026: '<i class="i-oc-sorry"></i><h3>抱歉，科技藍已售罄</h3><p>都是我不好，人數太多，機器太少，科技藍已售罄，建議您嘗試選擇其他顔色喔。</p>',
    tips_continue: '繼續購買',
    rtncode_41012: '<i class="i-oc-finished"></i><p>活動尚未開始，請閣下耐心等待喔</p>',
    rtncode_41018: '<i class="i-oc-finished"></i><p>玩客雲預售尚未開啟，請閣下耐心等待喔。</p>',
    rtncode_41022: '<i class="i-oc-finished"></i><p>活動尚未開啟，請閣下耐心等待喔。</p> ',
    rtncode_30303: '<i class="i-oc-finished"></i><p>滿減活動已結束</p>',

    fcode_notget: '未偵測到寶碼，去使用寶碼',
    fcode_use: '使用寶碼購買',
    fcode_tips: '溫馨貼士：玩客雲售後服務承諾，嚴格依據香港特別行政區當地相關法律實行售後服務',

    deposit_notbegin: '<i class="i-oc-finished"></i><h3>活動尚未開啓</h3><p>預售開啓時間：12月13日-19日 每天10:00-18:00，敬請期待</p>',
    deposit_end: '<i class="i-oc-finished"></i><h3>預售活動已結束</h3><p>玩客雲預售活動已結束，感謝您的支持！</p>',
    notifi_selectcolor: '請選擇顔色',
    notifi_selectdate: '請選擇發貨日期',
    deposit_tips_limit: '<h3>溫馨提示</h3><p>每個用戶只可提交2次預售訂單，檢測到您存在一筆超時失效預售訂單，本次提交訂單後請您盡快完成付款，如果再次支付超時，您將不能繼續參與本次預售活動。</p>',
    deposit_tips_queue: '<i class="i-oc-queue"></i><h3>正在排隊中，請不要刷新頁面</h3><p>當前參與預售的小夥伴較多，正在努力爲您排隊，請您耐心等待，不要刷新頁面喔。</p>',
    deposit_tips_yongdu: '<i class="i-oc-yongdu"></i><h3>抱歉，網絡走丟了</h3><p>當前購買人數較多，正在努力爲您加載，請稍候重試喔。</p>',
    deposit_tips_success: '<i class="i-oc-chenggong"></i><h3>恭喜你，已成功預定玩客雲1台</h3><p>該筆訂單支付有效期爲15分鍾，請盡快完成支付，逾期支付訂單將做失效處理。</p>',
    deposit_tips_queue2: '<i class="i-oc-queue"></i><h3>正在排隊中，請不要刷新頁面</h3><p>當前參與預售的小夥伴較多，正在努力爲您排隊，請您耐心等待，不要刷新頁面喔。</p>',
    product_title: '産品數量',
    product_num: '1台',

    deposit_rules: <div className="oc-buy-aside-rule"><h3>预售活动规则</h3><ol className="oc-buy-aside-rule-list"><li><strong>预售活动期间：</strong>12月13日-12月19日；</li><li><strong>预售开放时间：</strong>12月13日-19日 每天10:00-18:00；</li><li><strong>预售商品：</strong>玩客云，颜色为科技蓝、曜石黑、爱马仕橙；</li><li><strong>预售价格：</strong>399元全款预售；</li><li><strong>预售：</strong>是指您无需预约玩客云，选定发货时间后提前全款支付，以您支付成功系统告知发货时间为准，我们将按承诺的时间陆续为您安排发货；</li><li><strong>限购数量：</strong><strong>为充分保障用户权益，每个用户仅限购买1台玩客云，重复购买无效，已经成功在玩客云官网购买过玩客云的用户将无法参与本次预售活动；</strong></li><li><strong>发货时间：</strong><strong>预售商品的发货时间，在您选定发货时间档内按付款的先后顺序陆续安排发出，网心科技保留提前发货的权利，</strong>为了保证良好的用户体验，我们会在每月设置可发货的时间档位供用户选择；</li><li><strong>提交订单：</strong>请正确填写收货信息，选取配送方式并确认所选商品颜色、价格信息，请尽快提交订单，订单一旦提交将不可取消；</li><li><strong>支付时效：</strong><strong>请留意您的订单支付时效，订单生成后即进入15分钟支付倒计时，</strong>没有在支付时效内成功支付的订单，系统将视为您自动放弃并取消订单，您所占的发货时间名额也将被重新释放，已支付成功的订单视为本次预售下单成功；</li><li><strong>有关支付：</strong>每位用户可以下单2次，仅可成功购买1次。您在订单生成后实际付款前超过2次超时未支付订单，将失去继续参与本次预售活动的资格，用户完成支付的时间以第三方支付或银行提供给网心的支付流水时间为准；</li><li><strong>预售商品支付价格：</strong>以您支付成功时的价格为准，如预售商品发生调价，已支付订单将不受影响；</li><li><strong>预售订单快递：</strong>预售订单不支持自提，我们默认申通快递，如选顺丰快递，需额外支付18元快递费用；</li><li><strong>有关淘宝众筹优惠券：</strong>本次预售活动支持淘宝众筹期间购买的优惠券抵扣，请在优惠券有效期前完成使用，优惠券每个用户只能使用1张，不可叠加，一经使用立即作废，如使用优惠券后申请取消订单，退款时以实际支付金额为准；</li><li><strong>预售订单退款：</strong>预售订单在预售活动结束后至发货日的前一天中午12:00之前，用户可通过我的订单自动申请售后取消预售订单，客服在收到您的申请后，将于3-5个工作日内为您办理退款操作，预售订单发货后，退换货流程同正常订单一致；</li><li><strong>订单地址不可修改：</strong>为打击黄牛，收货信息将不可变更，请仔细确认您的收货信息，付款成功后将不可更改；</li><li><strong>防范黄牛：</strong>为保护广大用户的权益，打击黄牛高价倒卖，网心将保留取消恶意订单并给予退款的权利，一旦发现用户存在恶意刷单、一人多单、超时支付等违规行为，网心有权立即取消用户的订单并给予退款，且该用户失去继续参与本次预售活动的资格。网心有权依据本协议约定内容基于独立自主判断认定用户是否存在恶意刷单、一人多单、超时支付等违规行为，如用户对网心取消订单存有异议的，应当自其订单被取消起24小时内与网心联系，超过24小时的，视为用户不存有任何异议。</li></ol><h3>温馨提示：</h3><ol className="oc-buy-aside-rule-list"><li>玩客云官方购买渠道：玩客云PC版官网、移动版官网；</li><li>为确保您在更早的时间拿到商品，请在开售前校准您的电脑或手机时间；</li><li>由于近期玩客云包装LOGO进行了更新，新老包装将随机发货，敬请谅解；</li><li>如有任何疑问请拨打400-109-8880还可访问服务页<a href="http://wpa.qq.com/msgrd?v=3&uin=212454816&site=qq&menu=yes" target="_blank">联系QQ在线客服</a>，服务时间 09:00-21:00。</li></ol></div>,
    buy_steps: <div className="oc-buy-aside-steps"><h3>預定購買流程</h3><ol><li><h4>1. 預定購買</h4><p>預定即將開始</p></li><li className="oc-buy-aside-steps-arrow"></li><li><h4>2. 預付定金</h4><p>2017-08-10 10:10至2017-08-30: 18:00</p></li><li className="oc-buy-aside-steps-arrow"></li><li><h4>3. 支付尾款</h4><p>等待尾款時間開啓</p></li><li className="oc-buy-aside-steps-arrow"></li><li><h4>4. 發貨</h4><p>按定金支付順序依次發貨</p></li></ol></div>,

    verify_verify_refresh: '刷新題目',
    verify_input: '請輸入驗證碼',
    verify_yellow: '為保護用戶的利益，打擊黃牛，請您輸入一次驗證碼',
    verify_error:'驗證碼有誤，請重新填寫',
    verify_empty: '請輸入答案',


}


// WEBPACK FOOTER //
// ./js/src/i18n/purchase/hk.js